const $button = $('.mobile-menu__menu-button');
const $submenu = $('.mobile-menu__submenu ');
const $submenuButtom = $('.mobile-menu__back-button');
const acitveClass = 'active';

$(function () {
  $button.on('click', function () {
    const $this = $(this);

    if ($submenu.hasClass(acitveClass)) {
      $submenu.removeClass(acitveClass);
    }

    $this.parent().parent().find($submenu).toggleClass(acitveClass);
  });

  $submenuButtom.on('click', function () {
    if ($submenu.hasClass(acitveClass)) {
      $submenu.removeClass(acitveClass);
    }
  });
});
